import React from 'react';
import ReactDOM from 'react-dom';
import QuizPage from './Components/quizPage.jsx';
//import registerServiceWorker from './registerServiceWorker';

window.onload = () => {
	ReactDOM.render(<QuizPage />, document.getElementById('root'));
}
//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js